import { Typography } from '@mui/material'
import moment from 'moment'
import { HumanDate, ConditionallyRender } from 'components'
import { FormattedMessage } from 'react-intl'
import intl from 'localization/components'

interface UserData {
  last_login?: string
}

interface LastLoginViewProps {
  props: {
    userData?: UserData
  }
}

const LastLoginView = ({ props }: LastLoginViewProps) => {
  const lastLogin = props.userData?.last_login
  const daysSinceLastLogin = moment().diff(lastLogin, 'days')

  if (!props.userData) return <Typography sx={{ fontSize: 14 }}>-</Typography>

  return (
    <ConditionallyRender
      condition={daysSinceLastLogin < 30}
      when={<HumanDate style={{ color: 'orange', fontSize: 14 }} date={moment(lastLogin)} />}
      otherwise={
        lastLogin ? (
          <Typography sx={{ fontSize: 14 }}>
            <FormattedMessage id={intl.userManagement('more-than-30')} />
          </Typography>
        ) : (
          <Typography sx={{ fontSize: 14 }}>
            <FormattedMessage id={intl.userManagement('no-data-yet')} />
          </Typography>
        )
      }
    />
  )
}

export default LastLoginView
